import { useState, useEffect } from 'react';
import { Container, Box, Grid, useMediaQuery } from '@mui/material';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import PlanCard from './PlanCard';
import Header from './Header';
import Checkout from './Checkout';
import { Plan } from './types';
import { AlertInfo } from '../../components/Alerts/Alert';
import { api } from '../../services/api';
import SimpleBackdrop from '../../components/Loading/SimpleBackdrop';

export default function PricingPage() {
    const [activeStep, setActiveStep] = useState(1);
    const [selectedPlan, setSelectedPlan] = useState<string | null>("1");
    const [plans, setPlans] = useState<Plan[]>([]);
    const [openLoad, setOpenLoad] = useState(false);
    const isMobile = useMediaQuery('(max-width:768px)');

    const handleNext = () => {
        setActiveStep((prevStep) => Math.min(prevStep + 1, 3));
    };

    const handleBack = () => {
        setActiveStep((prevStep) => Math.max(prevStep - 1, 0));
    };

    const handlePlanSelect = (planId: string) => {
        setSelectedPlan(planId);
    };

    async function fetchPlans() {
        setOpenLoad(true);
        try {
            const response = await api.get(`/getplanssys`);
            if(response && response.data) setPlans(response.data);
        } catch (error) {
            console.log(error);
            AlertInfo({icon: 'error', title: 'Falha ao obter planos', text: 'Verifique a conexão com a internet'});
        }
        setOpenLoad(false);
    }

    const selectedPlanPrice = selectedPlan
        ? plans.find(plan => plan.cod_plan === selectedPlan)?.price_payment
        : null;

    const visiblePlans = isMobile ? [plans[activeStep]] : plans;

    useEffect(() => {
        fetchPlans();
    }, []);

    return (
        <Container maxWidth="lg">
            <SimpleBackdrop open={openLoad} />
            <Header />

            <Box sx={{ position: 'relative' }}>
                <Grid container spacing={2} justifyContent="center">
                    {visiblePlans.map((plan) => (
                        <Grid item xs={12} sm={6} md={3} key={plan.cod_plan}>
                            <PlanCard
                                plan={plan}
                                isSelected={selectedPlan === plan.cod_plan}
                                onSelect={handlePlanSelect}
                            />
                        </Grid>
                    ))}
                </Grid>

                {isMobile && (
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', position: 'absolute', top: '50%', left: 0, right: 0, transform: 'translateY(-50%)', px: 1, zIndex: 10 }}>
                        <Box
                            onClick={handleBack}
                            sx={{
                                bgcolor: 'background.paper',
                                borderRadius: '50%',
                                p: 1,
                                boxShadow: 2,
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                '&:hover': { bgcolor: 'secondary.light' }
                            }}
                        >
                            <ChevronLeft size={24} />
                        </Box>
                        <Box
                            onClick={handleNext}
                            sx={{
                                bgcolor: 'background.paper',
                                borderRadius: '50%',
                                p: 1,
                                boxShadow: 2,
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                '&:hover': { bgcolor: 'secondary.light' }
                            }}
                        >
                            <ChevronRight size={24} />
                        </Box>
                    </Box>
                )}
            </Box>

            {selectedPlan && selectedPlanPrice && (
                <Checkout selectedPlan={selectedPlan} planPrice={selectedPlanPrice} />
            )}
        </Container>
    );
};